import { useState } from "react";
import SimpleDialogWithErrorAndLoader from "../../atoms/Dialogs/SimpleDialogWithErrorAndLoader";
import url from "../../config/axios";

const DeleteBannerDialogComponent = ({
  bannerInfo: { _id, name },
  onCancel,
  onDone,
}) => {
  const initialFormState = {
    inProgress: false,
    error: null,
  };
  const [formState, setFormState] = useState(initialFormState);
  const deleteBanner = async () => {
    setFormState({ ...initialFormState, inProgress: true });
    url
      .delete(`/v1/consumer-banners/remove?_id=${_id}`)
      .then(() => {
        if (onDone instanceof Function) {
          onDone();
        }
      })
      .catch((e) => {
        // if(e.response?.data?.data?.)
        setFormState({
          ...initialFormState,
          loading: false,
          error:
            e.response?.data?.data?.message ?? "Unable to remove the banner.",
        });
      });
  };
  return (
    <SimpleDialogWithErrorAndLoader
      open={true}
      onDisagree={() => {
        if (!formState.inProgress && onCancel instanceof Function) {
          onCancel();
        }
      }}
      onAgree={() => {
        if (!formState.inProgress && onDone instanceof Function) {
          //   onDone();
          deleteBanner();
        }
      }}
      error={formState.error}
      loading={formState.inProgress}
      _agreeButtonText={"Yes"}
      _disagreeButtonText={"No"}
      _loadingButtonText="Deleting..."
      heading={`Are you sure want to delete the banner?`}
    ></SimpleDialogWithErrorAndLoader>
  );
};
export default DeleteBannerDialogComponent;
